export const columnNames = [
    "First Name",
    "Last Name",
    "Rank",
    "GPN",
    "GUI",
    //"Email Address",
    "Overall Category"
];

export const columnNamesOtherFormat = [
    "Last Name",
    "First Name",
    "GUI",
    "Rank",
    "Region",
    "Overall Category",
    "FINAL Finalization Form Commentary"
];